import { START_PAGE } from "../../utils/Constant";
import { GET_ALL_DASHBOARD_DATA } from "./ActionTypes";

export const getAllDashboardData = (payload, currentPage = START_PAGE) => ({
    type: GET_ALL_DASHBOARD_DATA,
    payload,
    currentPage,
  });